import React from "react";
import { BasicChequeredBoard, BasicChequeredBoardProps } from "../../components/BasicChequeredBoard/BasicChequeredBoard";
import { FaqAccordionGroupProps } from "../../components/FaqAccordionGroup/FaqAccordionGroup";
import { Paragraph, ParagraphProps } from "../../components/Paragraph";
import { ServiceCataloguePageWrapper } from "../../components/ServiceCataloguePageWrapper";
import { GenericListProps } from "../../types/GenericListType";
import { List } from "../../components/List";
import { Links, LinksProps } from "../../components/Links";
import { SeoHeaderProps } from "../../components/SeoHeader";

export interface NewElectricityConnectionPageProps {
  seo?: SeoHeaderProps;
  faqs?: FaqAccordionGroupProps;
  chequeredBoard?: BasicChequeredBoardProps;
  paragraphs?: ParagraphProps[];
  lists?: GenericListProps[];
  linksList?: LinksProps[];
  pageTitle: string;
}

export const NewElectricityConnectionPage: React.FC<NewElectricityConnectionPageProps> = ({
  seo,
  paragraphs,
  lists,
  chequeredBoard,
  linksList,
  faqs,
  pageTitle,
}) => {
  return (
    <ServiceCataloguePageWrapper seo={seo} title={pageTitle} faqs={faqs}>
      {paragraphs && paragraphs[0] && <Paragraph {...paragraphs[0]} />}
      {lists && lists[0] && <List {...lists[0]} />}
      {paragraphs && paragraphs[1] && <Paragraph {...paragraphs[1]} />}
      {chequeredBoard && <BasicChequeredBoard {...chequeredBoard} />}
      {linksList && linksList[0] && <Links {...linksList[0]} />}
    </ServiceCataloguePageWrapper>
  );
};
